import { React, useState } from "react";
import { CustomTable, Backdrop } from "components";
import { FiSearch } from "react-icons/fi";
import { otTableColumns, leaveTableColumns } from "../constants";
import StaffApplicationModal from "./StaffApplicationModal";
import { FiLoader } from "react-icons/fi";

// reactstrap components
import { Button, Row, Col } from "reactstrap";

const StaffApplications = ({ staff, type, isLoading }) => {
	const [displayLeaveModal, setDisplayLeaveModal] = useState(false);
	const [leaveToDisplay, setApplicationToDisplay] = useState({
		firstName: "",
		lastName: "",
		id: "",
		type: undefined,
		approvedReason: undefined,
	});

	const showDeleteModal = (leaveToDisplay) => {
		setApplicationToDisplay(leaveToDisplay);
		setDisplayLeaveModal(true);
	};

	const hideConfirmationModal = () => {
		setDisplayLeaveModal(false);
	};

	const [imgExpanded, expandImage] = useState(false);

	const actions = (row) => (
		<div className="actions-right">
			<Button color="warning" size="sm" className="btn-icon btn-link edit" onClick={() => showDeleteModal(row)}>
				<FiSearch size={20} />
			</Button>
		</div>
	);

	return (
		<>
			<Backdrop open={isLoading} fitToParent={true}>
				<div className="text-center position-absolute">
					<FiLoader size={40} className="animate-spin" />
				</div>
			</Backdrop>
			<StaffApplicationModal
				type={type}
				displayLeaveModal={displayLeaveModal}
				hideConfirmationModal={hideConfirmationModal}
				leaveToDisplay={leaveToDisplay}
				staff={staff}
				expandImage={expandImage}
				imgExpanded={imgExpanded}
			/>
			<Row>
				<Col className="order-2 md:order-1">
					<CustomTable
						data={staff?.applications.filter((application) => !application.isOt)}
						columns={leaveTableColumns}
						defaultPageSize={10}
						title={`${staff?.username || ""}'s Leaves`}
						actions={actions}
						loading={isLoading}
						marginClass={null}
					/>
				</Col>
			</Row>
		</>
	);
};

export default StaffApplications;
